import { useMediaQuery } from '@mui/material'
import useProfile from 'common/providers/useProfile'
import { useAuthSession } from 'hooks'
import { Link, useNavigate } from 'react-router-dom'
import { Avatars } from './../../../assets/avatars'
import { flags } from './../../../assets/flags'
import { Questionmark } from './../../../icons'
import Popover from './Popover'
import Constants from '../../../../../common/utils/constants'

interface HeaderAccountSectionProps {
  children?: React.ReactNode
}

const HeaderAccountSection = ({ children }: HeaderAccountSectionProps) => {
  const { isAuthenticated, clearSession } = useAuthSession()

  const navigate = useNavigate()
  const { profile } = useProfile()
  const isMediumOrLarger = useMediaQuery('(min-width: 640px)')
  return (
    <div className='navbar-action flex items-center justify-end pr-8 2xl:gap-8 gap-4'>
      <Link
        className='text-[#001A3D] font-medium inline-flex items-center gap-2 text-xs 2xl:text-base whitespace-nowrap'
        to={`mailto:${Constants.supportEmail}?subject=Customer%20Support`}
      >
        <Questionmark />{' '}
        <span className='hidden xl:contents'>Customer Support</span>
      </Link>
      <img src={flags.UK} alt='' />
      <span className='underline text-[#001A3D] font-medium text-xs 2xl:text-base whitespace-nowrap'>
        EN
      </span>
      {!isAuthenticated && isMediumOrLarger && (
        <Link to='/login' className='text-[#001A3D] font-medium'>
          Login
        </Link>
      )}
      {isAuthenticated && isMediumOrLarger ? (
        <Popover
          className='hidden md:flex'
          trigger={
            <button className='align-middle'>
              <img className='avatar' src={Avatars._Dummy} alt='' />
            </button>
          }
          content={
            <div className='flex flex-col items-start justify-evenly gap-y-5 h-full text-[16px]'>
              <h3 className='self-center font-medium text-[#1C7D93] '>
                {`${profile?.first_name || ''} ${profile?.last_name || ''}`}
              </h3>
              <div className='bg-white border-[0.4px] border-[#f4f4f4] w-full'>
                <div className='flex flex-col text-[#101828] gap-y-3 w-full'>
                  {[
                    { title: 'Profile', link: '/profile' },
                    { title: 'Appointments', link: '' },
                    { title: 'Documents library', link: '' },
                    { title: 'Favourites', link: '/favourites' },
                  ].map(({ title, link }) => (
                    <span className='hover:bg-[#EBFBFF] w-full rounded-md p-2'>
                      <Link className='w-[200px]' to={link}>
                        {title}
                      </Link>
                    </span>
                  ))}
                </div>
              </div>
              <button
                onClick={async () => {
                  clearSession()
                  navigate('/login')
                }}
                className='self-center font-bold text-[#1C7D93] '
              >
                Sign out
              </button>
            </div>
          }
          position='left'
          positionClassname='mt-10'
        />
      ) : (
        <img className='avatar' src={Avatars._Dummy} alt='' />
      )}
      {children}
    </div>
  )
}

export default HeaderAccountSection
